// @ts-nocheck

import type { PreviousPagesState } from '../states/previouspages';
import { PreviousPagesStateActionTypes } from '../types/actions/previouspages';

export const previouspagesInitialState: PreviousPagesState = {};

export default (state: PreviousPagesState = previouspagesInitialState, action: unknown) => {
  switch (action.type) {
    case PreviousPagesStateActionTypes.SET_PREVIOUS_PAGE: {
      const { page, pageNumber, anchorId } = action.payload ?? {};
      if (page) {
        return {
          ...state,
          [page]: { pageNumber, anchorId },
        };
      } else {
        return state;
      }
    }
    case PreviousPagesStateActionTypes.RESET_PREVIOUS_PAGE: {
      const { page } = action.payload ?? {};

      const nextState = { ...state };
      delete nextState[page];

      return nextState;
    }
    default:
      return state;
  }
};
